
/*----------------------
       SLIDER
---------------------- */
Slider = {
    init: function () {
        if ($(".swiper-sliderbig .swiper-slide").length > 1) {
            var swiper = new Swiper(".swiper-sliderbig", {
                effect: "fade",
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            });
        }
    }
};

$(document).ready(function () {
    Slider.init();
});
$(document).on('shopify:section:load', function (event) {
    Slider.init();
});

